module.exports = __webpack_public_path__ + "static/media/_MIC2427.thumbnail.7cf9675a.png";